package com.milta.core.localization.translations.nl

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Annuleren",
    confirm = "Bevestigen",
    save = "Opslaan",
    delete = "Verwijderen",
    back = "Terug",
    loading = "Laden…",
    retry = "Opnieuw proberen",
    creationInProgressDoNotClose = "Bezig met aanmaken, sluit het venster niet",
    processingStepSent = "Document verzonden",
    processingStepReading = "Document lezen",
    processingStepFinding = "Leveringen zoeken",
    processingStepChecking = "Adressen controleren",
    processingUsualDuration = "Meestal 20 tot 40 seconden. Blijf op dit scherm, wij doen de rest.",
    processingLongWait = "Uw document bevat veel informatie, de analyse duurt iets langer dan normaal. Alles werkt, we gaan door.",
    processingInProgressSince = "Bezig sinds %1",
    processingFinishedIn = "Klaar in %1",
    processingDeliveriesFound = "%1 leveringen gevonden",
    processingDeliveriesFoundOne = "1 levering gevonden",
    processingAddressesChecked = "%1 van %2 adressen",
    addressVerifiedBadge = "✓ Adres gecontroleerd",
    addressNeedsReviewBadge = "⚠ Adres te controleren",
    addressFoundLine = "Gevonden: %1",
    language = "Taal",
    welcomeTitle = "Welkom bij Milta",
    welcomeSubtitle = "Uw slimme bezorgassistent",
    alreadyHaveAccount = "Ik heb al een account",
    createAccount = "Account aanmaken",
    continueWithGoogle = "Doorgaan met Google",
    continueWithApple = "Doorgaan met Apple",
    oauthErrorGeneric = "Er is iets misgegaan bij het inloggen. Probeer het opnieuw.",
    oauthAppleWebComingSoon = "Inloggen met Apple komt binnenkort beschikbaar op het web.",
    oauthDriverAccountNotAllowedOnWeb = "Chauffeursaccounts hebben geen toegang tot het webdashboard. Log in via de mobiele app.",
    oauthAccountNotFoundOnWeb = "Er is geen Milta-account gevonden voor dit Google-account.",
    errorOffline = "Geen internetverbinding.",
    navTourneesDuJour = "Ritten van vandaag",
    navAjouterUneTournee = "Rit toevoegen",
    navHistoriqueDesPreuves = "Bezorggeschiedenis",
    navParametres = "Instellingen",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Nog geen bezorgingen",
    noDeliveriesYetSubtitle = "Tik op \"Bezorgingen toevoegen\" om er toe te voegen",
    optimizationUnavailableExplanation = "Wilt u de rit zonder optimalisatie aanmaken, of het opnieuw proberen?",
    createWithoutOptimizationAction = "Aanmaken zonder optimalisatie",
    gpsAppSheetTitle = "Kies een navigatie-app",
    addressSearchingLabel = "Zoeken…",
    clearTimeFieldAction = "Wissen",
    clearTimeFieldConfirmTitle = "Tijdstip wissen?",
    clearTimeFieldConfirmMessage = "Het huidige tijdstip wordt verwijderd. U kunt op elk moment een nieuw tijdstip instellen.",
    updateRequiredTitle = "Verplichte update",
    updateRequiredMessage = "Er is een nieuwe versie van Milta beschikbaar. Werk de app bij om ze te blijven gebruiken.",
    updateInstalledVersionLabel = "Geïnstalleerd",
    updateAvailableVersionLabel = "Beschikbaar",
    updateNowButton = "Bijwerken",
    updateDataKeptNote = "Je rondes en leveringen blijven bewaard.",
    updateSendingPendingOne = "1 offline gevalideerde levering wordt verzonden…",
    updateSendingPendingMany = "{count} offline gevalideerde leveringen worden verzonden…",
)
